interface CustomParams {
  [key: string]: unknown;
}

// Standard Facebook Pixel events
type StandardEvents =
  | 'AddPaymentInfo'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'CompleteRegistration'
  | 'Contact'
  | 'CustomizeProduct'
  | 'Donate'
  | 'FindLocation'
  | 'InitiateCheckout'
  | 'Lead'
  | 'PageView'
  | 'Purchase'
  | 'Schedule'
  | 'Search'
  | 'StartTrial'
  | 'SubmitApplication'
  | 'Subscribe'
  | 'ViewContent';

interface FbqCommands {
  init: [pixelId: string, additionalParams?: CustomParams];
  track: [eventName: StandardEvents, eventParams?: CustomParams];
  trackCustom: [eventName: string, eventParams?: CustomParams];
  trackSingle: [pixelId: string, eventName: StandardEvents, eventParams?: CustomParams];
  trackSingleCustom: [pixelId: string, eventName: string, eventParams?: CustomParams];
  consent: [action: 'revoke' | 'grant', eventParams?: CustomParams];
}

// Custom type for Facebook Pixel function
export interface FacebookPixelFunction {
  (command: 'init', ...args: FbqCommands['init']): void;
  (command: 'track', ...args: FbqCommands['track']): void;
  (command: 'trackCustom', ...args: FbqCommands['trackCustom']): void;
  (command: 'trackSingle', ...args: FbqCommands['trackSingle']): void;
  (command: 'trackSingleCustom', ...args: FbqCommands['trackSingleCustom']): void;
  (command: 'consent', ...args: FbqCommands['consent']): void;
  queue?: unknown[];
  loaded?: boolean;
  version?: string;
}

export function fbq(command: 'init', ...args: FbqCommands['init']): void;
export function fbq(command: 'track', ...args: FbqCommands['track']): void;
export function fbq(command: 'trackCustom', ...args: FbqCommands['trackCustom']): void;
export function fbq(command: 'trackSingle', ...args: FbqCommands['trackSingle']): void;
export function fbq(command: 'trackSingleCustom', ...args: FbqCommands['trackSingleCustom']): void;
export function fbq(command: 'consent', ...args: FbqCommands['consent']): void;
export function fbq(command: keyof FbqCommands, ...args: unknown[]): void {
  (window.fbq as any)(command, ...args);
}
